import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Btn from "../../components/common/Btn";
import HeadCont from "../../components/common/HeadCont";
import IdCard from "../../components/result/IdCard";

const Register = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();

  return (
    <>
      <HeadCont rightIcon={"no icon"} />
      <section className="mb-6 mt-14 space-y-6 p-6">
        <h2 className="text-subtitle3 text-gray_180">{t('messages.registration_complete')}</h2>
        <p className="text-body2_700l text-gray_160">
          {t('messages.health_card_issued')}
          <br />
          {t('messages.complete_health_survey')}
        </p>
        <IdCard />
        <Btn
          id={"signUpDone"}
          bgColor={"bg-main"}
          textColor={"text-white"}
          borderColor={"border border-main"}
          title={t('messages.complete_button')}
          active={"on"}
          onAction={() => navigate(`/home`)}
        />
      </section>
    </>
  );
};

export default Register;
